import Rx from 'rxjs/Rx';

export default class LoginService {
  constructor($http, host, ProfilePermissionsService) {
    this.http = $http;
    this.host = host;
    this.permissionsService = ProfilePermissionsService;
  }

  getAccountToken(accountId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: this.host + '/api/users/current-profile',
      data: {account_id: accountId}
    }).then(
      (resp) => resp.data.account_token,
      (resp) => console.log(resp.data)
    ));
  }

  getUserProfiles() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/users/profiles'
    }).then(
      (resp) => {
        var profiles = resp.data.profiles;
        var currentProfile = this.permissionsService.getProfile();

        if (currentProfile && profiles && profiles.length > 0) {
          var found = resp.data.profiles.find((p) => p.id === currentProfile.id);
          if (found) { this.permissionsService.setProfile(found); }
        }

        return profiles;
      },
      (resp) => []
    ));
  }

  getUserlanguage(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/users',
      params: {language: true}
    }).then(
      (resp) => resp.data,
      (resp) => 'ES'
    ));
  }

}

 LoginService.$inject = ['$http', 'host', 'ProfilePermissionsService'];


// WEBPACK FOOTER //
// ./src/app/services/login.service.js